import { imageUrl } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { responsiveSizes } from '@helpers/responsive';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import React from 'react';
import S from './TextImage.styles';
const TextImage = ({ content, cta, flush = 'none', hasBackground = false, image, imageMode = 'cover', imagePosition = 'left', title, }) => {
    const options = imageMode === 'cover'
        ? {
            sizes: [`${until(Device.Tablet)} 100vw`, `50vw`].join(', '),
            srcSet: responsiveSizes([{ value: 100, breakpoint: Device.Tablet }, { value: 50 }], image, { heightratio: 85 / 133, mode: 'crop' }),
        }
        : {};
    return (React.createElement(S.Container, { "data-image": !!image, "data-image-mode": imageMode, "data-image-position": imagePosition, flush: flush },
        React.createElement(S.Inner, { hasBackground: hasBackground },
            React.createElement(S.ContentWrapper, null,
                title && React.createElement(S.Title, null, title),
                content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                cta && (React.createElement(S.CtaHolder, null,
                    React.createElement(LinkButton, { themeOption: cta.themeOption ? cta.themeOption : 'green', title: cta?.text, href: cta?.url, target: cta?.target })))),
            image && (React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { alt: image?.altText, draggable: false, loading: "eager", role: "presentation", src: imageUrl(image, {}), ...options }))))));
};
export default TextImage;
